<template>
  <main class="admin-article-edit">
    <div class="admin-article-edit__wrapper">
      <div class="admin-article-edit__heading">
        <h1 class="admin-article-edit__page-title">Статья</h1>
        <router-link
          class="admin-article-edit__back"
          :to="{ name: 'AdminArticles' }"
        >
          Ко всем статьям →
        </router-link>
      </div>
      <validation-observer slim ref="form">
        <form
          novalidate
          @submit.prevent="submitForm"
          class="admin-article-edit__container"
        >
          <div class="admin-article-edit__data">
            <span class="admin-article-edit__data-title">Превью</span>
            <div>
              <validation-provider slim vid="preview" rules="required" v-slot="{ errors }">
                <input-textarea
                  v-model="articleData.previewText"
                  rows="4"
                  class="admin-article-edit__data-value"
                  :error="errors.length > 0"
                ></input-textarea>
              </validation-provider>
              <p class="admin-article-edit__hint">Превью – короткое название статьи на главной странице. 
                Можно использовать Enter для формирования иерархии в тексте
              </p>
            </div>
            <span class="admin-article-edit__data-title">Название</span>
            <validation-provider slim vid="title" rules="required" v-slot="{ errors }">
              <base-input v-model="articleData.title" class="admin-article-edit__data-value" :error="errors.length > 0"></base-input>
            </validation-provider>
            <span class="admin-article-edit__data-title">Описание</span>
            <validation-provider slim vid="descr" rules="required" v-slot="{ errors }">
              <input-textarea
                v-model="articleData.descr"
                rows="2"
                class="admin-article-edit__data-value"
                :error="errors.length > 0"
              ></input-textarea>
            </validation-provider>
            <span class="admin-article-edit__data-title">Дополнительно</span>
            <validation-provider slim vid="descr" rules="required" v-slot="{ errors }">
            <input-textarea
              v-model="articleData.more"
              rows="5"
              class="admin-article-edit__data-value"
              :error="errors.length > 0"
            ></input-textarea>
            </validation-provider>
          </div>
          <div class="admin-article-edit__button-wrapper">
            <base-button
              type="submit"
              :isError="isError"
              :isSuccess="isSuccess"
              class="admin-article-edit__save-btn"
            >{{ buttonText }}</base-button>
          </div>
          <div class="admin-article-edit__images-wrapper">
            <div class="admin-article-edit__images">
              <div class="block-element">
                <div class="block-element__image-wrapper">
                  <validation-provider
                    slim
                    vid="preview"
                    rules="image|size:10240"
                    v-slot="{ errors }"
                  >
                    <preview-image-input
                      v-model="articleData.preview.file"
                      :providedPreview="articleData.preview.url"
                      :error="errors.length > 0"
                    ></preview-image-input>
                  </validation-provider>
                </div>
                <span class="block-element__title">Обложка</span>
              </div>
              <div class="block-element">
                <div class="block-element__image-wrapper">
                  <validation-provider
                    slim
                    vid="textImage"
                    rules="image|size:10240"
                    v-slot="{ errors }"
                  >
                    <preview-image-input
                      v-model="articleData.textImage.file"
                      :providedPreview="articleData.textImage.url"
                      :error="errors.length > 0"
                    ></preview-image-input>
                  </validation-provider>
                </div>
                <span class="block-element__title">Фото с текстом</span>
              </div>
              <template v-for="(item, index) in articleData.blocks">
                <div
                  :key="item.id"
                  class="block-element block-element_big"
                >
                  <div class="block-element__image-wrapper block-element__image-wrapper_big">
                    <image-block class="block-element__image" :item="item"></image-block>
                  </div>
                  <div class="block-element__controls">
                    <button
                      type="button"
                      @click="moveBlockUp(index)"
                      v-show="index != 0"
                      class="block-element__action"
                    >
                      Вперёд
                    </button>
                    <button
                      type="button"
                      @click="moveBlockDown(index)"
                      v-show="index != articleData.blocks.length - 1"
                      class="block-element__action"
                    >
                      Назад
                    </button>
                    <button
                      type="button"
                      @click="deleteBlock(index)"
                      class="block-element__action"
                    >
                      Удалить
                    </button>
                  </div>
                </div>
              </template>
              <div class="new-block">
                <div class="new-block__wrapper">
                  <div class="new-block__content">
                    <button
                      type="button"
                      @click="addNewWholeBlock"
                      class="new-block__horizontal"
                    >горизонтальный</button>
                    <button
                      type="button"
                      @click="addNewHalfBlock"
                      class="new-block__vertical"
                    >вертикальные</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
    </div>
  </main>
</template>

<script>
import BaseInput from '../components/BaseInput'
import InputTextarea from '../components/InputTextarea'
import BaseButton from '../components/BaseButton'
import PreviewImageInput from '../components/PreviewImageInput'
import ImageBlock from '../components/ImageBlock'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { extend } from 'vee-validate'
import { required, alpha_spaces, image, size } from 'vee-validate/dist/rules'

import { apiGetArticle, apiUploadArticleImage, apiUpdateArticle } from '../utils/api'

import { v4 as uuid } from 'uuid'

extend('required', required)
extend('alpha_spaces', alpha_spaces)
extend('image', image)
extend('size', size)

export default {
  name: 'AdminArticleEdit',
  components: {
    BaseInput,
    BaseButton,
    InputTextarea,
    PreviewImageInput,
    ImageBlock,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      isUploading: false,
      isError: false,
      isSuccess: false,
      articleData: {
        preview: { url: '', filePath: '', file: '' },
        textImage: { url: '', filePath: '', file: '' },
        previewText: '',
        title: '',
        descr: '',
        more: '',
        blocks: []
      },
      deletedBlocks: []
    }
  },
  computed: {
    buttonText() {
      if (this.isUploading) {
        return 'сохранение...'
      } else if (this.isError) {
        return 'ошибка'
      } else if (this.isSuccess) {
        return 'сохранено'
      } else {
        return 'сохранить'
      }
    }
  },
  async mounted() {
    try {
      this.articleData = await apiGetArticle(this.$route.params.id)
      this.articleData.preview.file = ''
      for (let block of this.articleData.blocks) {
        for (let image of block.images) {
          image.file = ''
        }
      }
    } catch(e) {
      console.error(e.message)
    }
  },
  methods: {
    addNewWholeBlock() {
      this.articleData.blocks.push({ id: uuid(), type: 'whole', images: [{ url: '', filePath: '', file: '' }] })
    },
    addNewHalfBlock() {
      this.articleData.blocks.push({ id: uuid(), type: 'half', images: [
        { url: '', filePath: '', file: '' },
        { url: '', filePath: '', file: '' }
      ]})
    },
    async submitForm() {
      if (this.isUploading) {
        return
      }
      this.isUploading = true
      let success = await this.$refs.form.validate()
      if (!success) {
        this.isUploading = false
        this.isError = true
        setTimeout(() => this.isError = false, 2000)
        return
      }
      // 1. download all new images and delete old (if needed)
      const uploadTasks = []
      // 1.1 preview
      if (this.articleData.preview.file) {
        const previewData = new FormData()
        previewData.append('image', this.articleData.preview.file)
        previewData.append('delete', this.articleData.preview.filePath)
        const promise = apiUploadArticleImage(previewData)
          .then((data) => { 
            this.articleData.preview.url = data.url
            this.articleData.preview.filePath = data.filePath
          })
          .catch((error) => { console.error(error.message) })
        uploadTasks.push(promise)
      }
      // 1.2 textImage
      if (this.articleData.textImage.file) {
        const textImageData = new FormData()
        textImageData.append('image', this.articleData.textImage.file)
        textImageData.append('delete', this.articleData.textImage.filePath)
        const promise = apiUploadArticleImage(textImageData)
          .then((data) => { 
            this.articleData.textImage.url = data.url
            this.articleData.textImage.filePath = data.filePath
          })
          .catch((error) => { console.error(error.message) })
        uploadTasks.push(promise)
      }
      // 1.3 blocks
      for (let block of this.articleData.blocks) {
        for (let image of block.images) {
          if (image.file) {
            const imageData = new FormData()
            imageData.append('image', image.file)
            imageData.append('delete', image.filePath)
            const promise = apiUploadArticleImage(imageData)
              .then((data) => { 
                image.url = data.url
                image.filePath = data.filePath
              })
              .catch((error) => { console.error(error.message) })
            uploadTasks.push(promise)
          }
        }
      }
      // 2. delete all images from deleted blocks
      for (let block of this.deletedBlocks) {
        for (let image of block.images) {
          if (image.filePath) {
            const imageData = new FormData()
            imageData.append('image', '')
            imageData.append('delete', image.filePath)
            const promise = apiUploadArticleImage(imageData)
              .catch((error) => { console.error(error.message) })
            uploadTasks.push(promise)
          }
        }
      }
      this.deletedBlocks = []
      await Promise.allSettled(uploadTasks)
      // 3. upload updated article
      const data = Object.assign({}, this.articleData)
      delete data.preview.file
      delete data.textImage.file
      // strip all empty blocks
      data.blocks = data.blocks.filter((el) => {
        let isEmpty = true
        for (let image of el.images) {
          if (image.filePath) {
            isEmpty = false
            break
          }
        }
        return !isEmpty
      })
      try {
        await apiUpdateArticle(JSON.stringify(data))
        this.isUploading = false
        this.isSuccess = true
        setTimeout(() => {
          this.isSuccess = false
          this.$router.push({ name: 'AdminArticles' })
        }, 2000)
      } catch(e) {
        console.error(e.message)
        this.isUploading = false
        this.isError = true
        setTimeout(() => this.isError = false, 2000)
      }

      this.isUploading = false
    },
    moveBlockUp(index) {
      this.articleData.blocks.splice(index-1, 2, this.articleData.blocks[index], this.articleData.blocks[index-1])
    },
    moveBlockDown(index) {
      this.articleData.blocks.splice(index, 2, this.articleData.blocks[index+1], this.articleData.blocks[index])
    },
    deleteBlock(index) {
      this.deletedBlocks.push(this.articleData.blocks.splice(index, 1)[0])
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.admin-article-edit {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 60px 45px 40px;
  &__wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1328px;
  }
  &__heading {
    margin-bottom: 30px;
  }
  &__page-title {
    display: inline-block;
    font-size: 22px;
    line-height: 40px;
    text-transform: uppercase;
    margin-right: 20px;
  }
  &__back {
    text-decoration: none;
    color: colors.$blue03;
  }
  &__container {
    flex-grow: 1;
    display: grid;
    grid-template-columns: 0.5fr 1fr;
    grid-template-rows: auto 1fr;
    column-gap: 65px;
    row-gap: 36px;
  }
  &__data {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 135px minmax(250px, auto);
    grid-template-rows: repeat(4, minmax(35px, auto));
    row-gap: 10px;
  }
  &__button-wrapper {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }
  &__save-btn {
    margin-left: 135px;
  }
  &__images-wrapper {
    grid-column: 2 / 3;
    grid-row: 1 / 3;
  }
  &__images {
    display: grid;
    grid-template-columns: repeat(4, minmax(190px, 1fr));
    column-gap: 10px;
    row-gap: 10px;
    justify-content: end;
  }
  &__data-title {
    padding-top: 8px;
    font-size: 14px;
    color: colors.$gray7f;
  }
  &__hint {
    padding: 12px 0 10px;
    font-size: 12px;
    color: colors.$gray7f;
  }
  &__data-value {
    font-size: 16px;
  }
  &__image-wrapper {
    position: relative;
    padding-top: 120%;
  }
}

.block-element {
  &_big {
    grid-column: auto / span 2;
  }
  &__image-wrapper {
    position: relative;
    padding-top: 120%;
    &_big {
      padding-top: 58.5%;
    }
  }
  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &__title {
    display: block;
    margin-top: 10px;
    font-size: 14px;
    color: colors.$gray8b;
  }
  &__controls {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
  &__action {
    padding: 0;
    font-size: 12px;
    background-color: transparent;
    border: none;
    color: colors.$gray8b;
    cursor: pointer;
    &:not(:last-child) {
      margin-right: 10px;
    }
    &:hover {
      color: #000;
    }
  }
}

.new-block {
  grid-column: auto / span 2;
  position: relative;
  &__wrapper {
    position: relative;
    padding-top: 58%;
  }
  &__content {
    position: absolute;
    top: calc(50% - 37.5px);
    left: 15%;
    width: 70%;
    height: 75px;
  }
  &__horizontal, &__vertical {
    @include fonts.mo-semi;
    width: 100%;
    height: 35px;
    box-sizing: border-box;
    font-size: 11px;
    background-color: #fff;
    border: 1px solid #000;
    cursor: pointer;
  }
  &__horizontal {
    margin-bottom: 5px;
  }
}

@media screen and (max-width: 1328px) {
  .admin-article-edit {
    &__images {
      grid-template-columns: repeat(2, minmax(190px, 1fr));
    }
  }
  .new-block {
    &__wrapper {
      padding: 0;
    }
    &__content {
      display: flex;
      justify-content: space-between;
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
    }
    &__horizontal, &__vertical {
      @include fonts.mo-semi;
      width: 48%;
    }
    &__horizontal {
      margin: 0;
    }
  }
}

@media screen and (max-width: 1023px) {
  .admin-article-edit {
    padding: 50px 12px 25px;
    &__container {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      row-gap: 25px;
    }
    &__data {
      grid-column: 1 / 2;
      grid-row: 1 / 2;
      grid-template-columns: 135px auto;
    }
    &__button-wrapper {
      grid-column: 1 / 2;
      grid-row: 3 / 4;
    }
    &__save-btn {
      margin: 0;
      width: 100%;
    }
    &__images-wrapper {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
    }
    &__images {
      grid-template-columns: repeat(4, minmax(150px, 1fr));
      justify-content: start;
    }
  }
  .new-block {
    &__wrapper {
      padding-top: 58%;
    }
    &__content {
      display: block;
      position: absolute;
      top: calc(50% - 37.5px);
      left: 15%;
      width: 70%;
      height: 75px;
    }
    &__horizontal, &__vertical {
      @include fonts.mo-semi;
      width: 100%;
    }
    &__horizontal {
      margin-bottom: 5px;
    }
  }
}

@media screen and (max-width: 767px) {
  .admin-article-edit {
    &__images {
      grid-template-columns: repeat(2, minmax(150px, 1fr));
    }
  }
  .new-block {
    &__wrapper {
      padding: 0;
    }
    &__content {
      display: flex;
      justify-content: space-between;
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
    }
    &__horizontal, &__vertical {
      @include fonts.mo-semi;
      width: 48%;
    }
    &__horizontal {
      margin: 0;
    }
  }
}
</style>